import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the collaboratorsEdit state domain
 */
 export const makeSelectLanguage = () =>
 createSelector(selectCollaboratorsEditDomain, (state) => state.get("languages"))

export const makeSelectIsLoadingLanguage = () =>
 createSelector(selectCollaboratorsEditDomain, (state) =>
   state.get("isLoadingLanguage")
 )

const selectCollaboratorsEditDomain = (state) =>
  state.get("collaboratorsEdit", initialState)

export const MakeSelectIsUpdating = () =>
  createSelector(selectCollaboratorsEditDomain, (state) =>
    state.get("isUpdating")
  )

export const MakeSelectDivisions = () =>
  createSelector(selectCollaboratorsEditDomain, (state) =>
    state.get("divisions")
  )

export const MakeSelectGenders = () =>
  createSelector(selectCollaboratorsEditDomain, (state) => state.get("genders"))

export const MakeSelectLocations = () =>
  createSelector(selectCollaboratorsEditDomain, (state) =>
    state.get("locations")
  )

export const MakeSelectLeaders = () =>
  createSelector(selectCollaboratorsEditDomain, (state) => state.get("leaders"))

export const MakeSelectCategories = () =>
  createSelector(selectCollaboratorsEditDomain, (state) =>
    state.get("categories")
  )

export const MakeSelectCurrency = () =>
  createSelector(selectCollaboratorsEditDomain, (state) =>
    state.get("currencies")
  )

export const makeSelectCollaborator = () =>
  createSelector(selectCollaboratorsEditDomain, (state) =>
    state.get("collaborator")
  )

export const makeSelectIsLoadingCollaborator = () =>
  createSelector(selectCollaboratorsEditDomain, (state) =>
    state.get("isLoadingCollaborator")
  )

export const makeSelectIsLoadingMeasures = () =>
  createSelector(selectCollaboratorsEditDomain, (state) =>
    state.get("isLoadingMeasures")
  )

export const makeSelectMeasuresAffected = () =>
  createSelector(selectCollaboratorsEditDomain, (state) =>
    state.get("measuresAffected")
  )

/**
 * Other specific selectors
 */

/**
 * Default selector used by CollaboratorsEdit
 */

const makeSelectCollaboratorsEdit = () =>
  createSelector(selectCollaboratorsEditDomain, (substate) => substate.toJS())

export default makeSelectCollaboratorsEdit
export { selectCollaboratorsEditDomain }
